import { useQueryClient } from '@tanstack/react-query';

import { ResultListModel } from '@common-lib';

import { RuleListModel, ruleClient } from '@portal-clients/rule';

import { useInfiniteScrollClientQuery } from '@frontend/hooks';
import { usePortalConfiguration } from '@frontend/utils';

const fetchRules = async (pageToken: string | undefined) => {
  return ruleClient.list({
    pageSize: 20,
    pageToken,
  });
};

export interface UseRuleProps {
  onError?(): void;
}

export const getRuleQueryKey = () => ['rules'];

export const useRuleQuery = ({ onError }: UseRuleProps = {}) => {
  const { config } = usePortalConfiguration();

  return useInfiniteScrollClientQuery({
    queryKey: getRuleQueryKey(),
    enabled: !!config.features?.rule?.enabled,
    onFetch: async (pageToken) => {
      return await fetchRules(pageToken);
    },
    onError,
  });
};

export const usePrefetchRulesQuery = () => {
  const queryClient = useQueryClient();
  const { config } = usePortalConfiguration();

  if (!config.features?.rule?.enabled) {
    return;
  }

  queryClient.prefetchInfiniteQuery({
    pages: 1,
    queryKey: getRuleQueryKey(),
    initialPageParam: undefined,
    getNextPageParam: (lastPage: ResultListModel<RuleListModel>) => {
      return lastPage.nextPageToken;
    },
    queryFn: async ({ pageParam: pageToken }) => {
      return await fetchRules(pageToken);
    },
  });
};
